<div class="layout-wrapper" >
  <div class="layout-topbar">
    <div class="layout-topbar-content">
      <a href="#" id="menu-btn" class="menu-btn" (click)="app.onMobileMenuButton($event)">
        <i class="pi pi-bars"></i>
      </a>
    </div>
  </div>
  <div class="layout-sidebar" [ngClass]="{'layout-sidebar-active':app.mobileMenuActive}" style="z-index:50; overflow-y: auto !important;height: calc(100vh - 4rem);">
    <ul class="layout-menu" *ngFor="let item of items2; let i = index" (click)="app.hideMobileMenu($event)">
      <li *ngIf="item.storyId !== 'renovation' && item.storyId.indexOf('http')  < 0 && item.storyId.indexOf('close')  < 0" >
        <a routerLinkActive="active" (click)="changetitle(item.title, item.storyId)" [routerLinkActiveOptions]="{exact:true}">
          <i class="pi {{item.image}}" style="font-size: 2rem"></i>
          <span>{{item.title}}</span>
        </a>
      </li>
      <li *ngIf="item.storyId.indexOf('http') > -1">
        <a (click)="newWindow(item.storyId)">
          <i class="pi {{item.image}}" style="font-size: 2rem"></i>
          <span>{{item.title}}</span>
        </a>
      </li>
      <li *ngIf="item.storyId.indexOf('close') > -1">
        <a (click)="close()">
          <i class="pi {{item.image}}" style="font-size: 2rem"></i>
          <span>{{item.title}}</span>
        </a>
      </li>
      <li *ngIf="env.renovation!= null && env.renovation['code'] == '709' && item.storyId == 'renovation'">
        <a [routerLink]= "item.storyId" routerLinkActive="active" (click)="changetitle(item.title, item.storyId)" [routerLinkActiveOptions]="{exact:true}">
          <i class="pi {{item.image}}" style="font-size: 2rem"></i>
          <span>{{item.title}}</span>
        </a>
      </li>
    </ul>
  </div>
  <div class="progress-spinner" *ngIf="env.isContentLoading">
      <img src="assets/images/Logo-1.gif" alt="" width="18%">
  </div>
  <div class="layout-content" style=" margin-top: 0px">
    <p-toast></p-toast>
    <p-steps [model]="itemsStep"  [(activeIndex)]="env.activeIndex" [readonly]="false" *ngIf="env.showSteps"></p-steps>
    <router-outlet>
    </router-outlet>
  </div>
</div>
